'use es6';

import I18n from 'I18n';
import { Select } from 'foundations-components/transitional/components/Select';
import { Paginator } from 'foundations-components/transitional/components/Paginator';
import { MAX_VISIBLE_PAGES } from 'reporting-data/constants/paginationSettings';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LEGACY_PER_PAGE_DEFAULT_VALUE = 25;
const PER_PAGE_DEFAULT = 10;
const PER_PAGE_OPTIONS = [PER_PAGE_DEFAULT, 20, 30, 40, 50, 60, 70, 80, 90, 100];
const getPerPageOptionText = number => I18n.text('reporting-ui-components.table.rowsPerPage', {
  number
});
const getRowsPerPageOptions = () => PER_PAGE_OPTIONS.map(number => ({
  text: getPerPageOptionText(number),
  value: String(number)
}));
const ReportPaginator = ({
  page,
  pageCount,
  itemsPerPage,
  onPageChange,
  onPerPageChange
}) => {
  if (pageCount === 1 && !onPerPageChange) {
    return null;
  }
  const paginator = /*#__PURE__*/_jsx(Paginator, {
    "data-test-id": "ui-paginator",
    onPageChange: ({
      target: {
        value
      }
    }) => onPageChange(value),
    page: page,
    pageCount: pageCount,
    maxVisiblePageButtons: MAX_VISIBLE_PAGES,
    showFirstLastButtons: false
  });

  // We only want to support having the legacy per page value selected initially,
  // so we can set the full text as the value instead of creating a real option
  // and it will disappear from the select after changing to a supported value
  const rowsPerPageSelectValue = itemsPerPage === LEGACY_PER_PAGE_DEFAULT_VALUE ? getPerPageOptionText(LEGACY_PER_PAGE_DEFAULT_VALUE) : String(itemsPerPage);
  if (!onPerPageChange || ![LEGACY_PER_PAGE_DEFAULT_VALUE, ...PER_PAGE_OPTIONS].find(item => item === parseInt(itemsPerPage, PER_PAGE_DEFAULT))) {
    return /*#__PURE__*/_jsx(View, {
      "data-test-id": "report-paginator-with-static-rows-per-page",
      marginBlock: "200",
      children: paginator
    });
  }
  return /*#__PURE__*/_jsxs(Flex, {
    "data-test-id": "report-paginator-with-dynamic-rows-per-page",
    marginBlock: "200",
    alignItems: "center",
    justifyContent: "center",
    flexWrap: "nowrap",
    children: [paginator, /*#__PURE__*/_jsx(Select, {
      buttonUse: "link",
      menuWidth: 250,
      onChange: onPerPageChange,
      options: getRowsPerPageOptions(),
      value: rowsPerPageSelectValue,
      searchable: false
    })]
  });
};
export default ReportPaginator;